import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './privacy.module.css';

import { useSidebarProvider } from '../../../providers/SidebarProvider.js';

const Privacy = ({setSelectedMenuItem}) => {
  const { setIsSidebarShowing } = useSidebarProvider();


  useEffect(() => {
    // If the page is loading on a small width, hide the sidebar so you see the page
    if (window.innerWidth < 1300){
      setIsSidebarShowing(false);
    }
    setSelectedMenuItem("");
  },[]);

  return (
    <div className={styles.Privacy}>
      <div className={styles.Title}>Privacy Policy</div>
      <div className={styles.Body}>
        <div className={styles.SubTitle} style={{fontWeight:'600'}}>**Effective Date:** July 15th 2024</div>

        <div className={styles.SubTitle}>**Introduction**</div>
        <div>Cross Club Pickleball League (CPL) is committed to protecting the privacy and security of your personal information. This Privacy Policy outlines how we collect, use, disclose, and protect your information when you participate in CPL activities or interact with our website and services.</div>
<br/>      
        <div className={styles.SubTitle}>**1. Information We Collect**</div>
        <div>
          <div>We may collect the following types of information:</div>
          <ul>
            <li>**Personal Identification Information:** Name, address, email address, phone number, date of birth, and emergency contact information.</li>
            <li>**Photographs and Videos:** Images and videos captured during CPL events.</li>
            <li>**Payment Information:** Credit card details or other financial information for processing payments.</li>
            <li>**Health Information:** Any medical conditions or information voluntarily provided to ensure safe participation in CPL activities.</li>
            <li>**Usage Data:** Information on how you interact with our website, including IP addresses, browser type, and pages visited.</li>
          </ul>
        </div>

        <div className={styles.SubTitle}>**2. How We Use Your Information**</div>
        <div>
          <div>CPL uses the information collected for various purposes, including:</div>
          <ul>
            <li>To manage and administer your participation in CPL activities</li>
            <li>To process payments and manage transactions.</li>
            <li>To communicate with you regarding CPL events, updates, and promotions.</li>
            <li>To ensure the safety and security of participants.</li>
            <li>To post names and photos on social media, our website, or other platforms, as consented.</li>
            <li>To improve our website and services through analysis of usage data.</li>
          </ul>
        </div>

        <div className={styles.SubTitle}>**3. Disclosure of Your Information**</div>
        <div>
          <div>We may share your personal information in the following circumstances:</div>
          <ul>
            <li>**With Service Providers:** To perform services on our behalf, such as payment processing and event management.</li>
            <li>**For Legal Requirements:** If required by law or to comply with legal processes.</li>
            <li>**With Your Consent:** When you have given explicit consent to share your information.</li>
            <li>**In Case of Emergencies:** To medical personnel in the event of an emergency.</li>
          </ul>
        </div>

        <div className={styles.SubTitle}>**4. Data Security**</div>
        <div>
          <div>CPL takes reasonable measures to protect your information from unauthorized access, use, or disclosure. We implement appropriate technical and organizational security measures to safeguard your data.</div>
        </div>

        <div className={styles.SubTitle}>**5. Your Data Protection Rights**</div>
        <div>
          <div>You have the following rights regarding your personal information:</div>
          <ul>
            <li>**Access:** You can request copies of your personal data.</li>
            <li>**Rectification:** You can request correction of any inaccurate or incomplete data.</li>
            <li>**Erasure:** You can request deletion of your personal data under certain conditions.</li>
            <li>**Restriction:** You can request restriction of processing your personal data.</li>
            <li>**Objection:** You can object to the processing of your personal data.</li>
            <li>**Data Portability:** You can request transfer of your data to another organization or directly to you.</li>
          </ul>
          <div>To exercise these rights, please contact us using the contact information provided below.</div>
        </div>

        <div className={styles.SubTitle}>**6. Children's Privacy**</div>
        <div>
          <div>CPL does not knowingly collect personal information from children under the age of 13. If we become aware that we have inadvertently received personal information from a child under 13, we will delete such information from our records.</div>
        </div>

        <div className={styles.SubTitle}>**7. Changes to This Privacy Policy**</div>
        <div>
          <div>CPL reserves the right to update or modify this Privacy Policy at any time. We will notify you of any changes by posting the new Privacy Policy on our website. Changes are effective immediately upon posting.</div>
        </div>

        <div className={styles.SubTitle}>**8. Contact Us**</div>
        <div>
          <div>If you have any questions or concerns about this Privacy Policy or the handling of your personal information, please contact us at: </div>
          <Link to="/contact-us">Contact Us</Link>
        </div>

      </div>

    </div>
  )
}

export default Privacy;